import { Check, Info, Minus } from "lucide-react";
import { GLASS_LABELS, INCLUDE_LABELS, UNIT_LABELS, VAT_LABELS, formatPrice, nlDate } from "../../lib/productPrices";
import { QuoteButton } from "../home/CtaButtons";
import { CompareLink } from "../info/InfoHero";

const itemLabel = (k, p) => (k === "glas" && p.glass ? GLASS_LABELS[p.glass] : INCLUDE_LABELS[k]);

// Transparante weergave van een door de eigenaar goedgekeurde prijsindicatie.
export const PriceDetails = ({ p, testid = "price-details" }) => (
  <div data-testid={testid}>
    <p className="text-[12px] font-semibold uppercase tracking-[0.14em] text-gold">Indicatieve prijs</p>
    <p className="mt-2 font-display text-[28px] font-bold leading-tight text-ink sm:text-[30px]" data-testid={`${testid}-amount`}>{formatPrice(p)}</p>
    <p className="text-[14px] text-slate-500">{UNIT_LABELS[p.unit]} · {VAT_LABELS[p.vat || "incl"]}</p>
    {p.example && <p className="mt-3 text-[14px] text-slate-600">{p.example}</p>}
    <ul className="mt-4 grid gap-1.5" data-testid={`${testid}-includes`}>
      {Object.keys(INCLUDE_LABELS).filter((k) => p.includes?.includes(k) || p.excludes?.includes(k)).map((k) => {
        const yes = p.includes?.includes(k);
        return (
          <li key={k} className={`flex items-center gap-2 text-[14px] ${yes ? "text-slate-700" : "text-slate-500"}`}>
            {yes ? <Check className="h-4 w-4 shrink-0 text-maas" aria-hidden="true" /> : <Minus className="h-4 w-4 shrink-0 text-slate-400" aria-hidden="true" />}
            <span>{itemLabel(k, p)}{yes ? "" : <span className="sr-only">:</span>}{!yes && <span className="ml-1 text-[12.5px]">— niet inbegrepen</span>}</span>
          </li>
        );
      })}
    </ul>
    {p.excluded_note && <p className="mt-2 text-[13.5px] text-slate-500">Niet inbegrepen: {p.excluded_note}</p>}
    {p.note && <p className="mt-3 text-[13.5px] text-slate-500">{p.note}</p>}
    <p className="mt-4 flex gap-2 rounded-xl bg-slate-50 p-3 text-[12.5px] leading-relaxed text-slate-500"><Info className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
      Indicatief. De definitieve prijs hangt af van afmetingen, uitvoering, materialen en montagesituatie en volgt na het inmeten.{p.price_updated_at ? ` Prijs bijgewerkt op ${nlDate(p.price_updated_at)}.` : ""}</p>
  </div>
);

export const PriceCtas = ({ location, onderwerp }) => (
  <div className="mt-5 flex flex-col gap-4">
    <QuoteButton location={location} onderwerp={onderwerp} className="w-full" label="Ontvang vrijblijvend een persoonlijke prijsindicatie" />
    <CompareLink location={location} label="Heeft u al een offerte? Vergelijk uw offerte" />
  </div>
);
